module.exports = __webpack_public_path__ + "static/media/timesheet_Details2.3ad1685c.png";